import { xtwhUrls } from '@shared/urls/xtwhUrls';
import { NzMessageService } from 'ng-zorro-antd';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.less'],
})
export class AccountSettingsComponent implements OnInit {
  userInfo = {
    name: '',
    email: '',
    phone: '',
    sex: '',
    code: '',
    userName: '',
    avatarUrl: '',
    profile: '',
  };

  constructor(private http: HttpClient, private msg: NzMessageService, private message: NzMessageService) {
  }

  // 查询个人信息
  queryUserInfo() {
    this.http.post(xtwhUrls.userConfig.getUserDetail, {}).subscribe((response: any) => {
      console.log('个人信息', response);
      if (response.err_code === 2000) {
        this.userInfo.userName = response.name;
        this.userInfo.phone = response.phone;
        this.userInfo.email = response.email;
        this.userInfo.sex = response.sex;
        this.userInfo.code = response.ghhxh;
        this.userInfo.profile = response.profile;
        this.userInfo.avatarUrl = `${xtwhUrls.files.downloadFile_icon}?fileName=${response.avatarId}`;
        console.log(this.userInfo);
      } else {
        this.msg.error(response.err_msg);
      }
    });
  }

  ngOnInit() {
    this.queryUserInfo();
  }
}
